import { useState, useCallback } from 'react'
import { BookMarkRoutesParsedTy } from '../../../../../app/erp/types'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { changeEmployeeParams } from '../../../../../utils/reducers/reduxDispatch'
import { ButtonPrimary } from '../../../../Button'
import LoaderDecider from '../../../../LoaderDecider'
import { ModalMedium } from '../../../../Modal'
import { ModalOpenedTy } from '../../../../Modal/types'
import { VerticalSortListDelete } from '../../../../Sorts/VerticalSortList'
import { VerticalSortItem } from '../../../../Sorts/VerticalSortList/types'
import TwinTrans from '../../../../TwinTrans'

interface ModalPersonalizeBookmarksProps extends ModalPersonalizeBookmarksLogicProps { }

const ModalPersonalizeBookmarks: React.FC<ModalPersonalizeBookmarksProps> = ({ bookMarkParsedDict, setOpened }) => {
    const { data, setData, myUpdateOrder } = useModalPersonalizeBookmarksLogic({ bookMarkParsedDict, setOpened })
    return (
        <ModalMedium opened={true} setOpened={setOpened} className='flex flex-col text-gray-51'>
            <h2 className='mb-35'>
                <TwinTrans transKey='updateBookmarksOrder'>Actualizar el orden de tus marcadores</TwinTrans>
            </h2>
            <LoaderDecider loading={data === null}>
                {data !== null && <VerticalSortListDelete items={data as any} setItems={setData}></VerticalSortListDelete>}
            </LoaderDecider>
            <ButtonPrimary className='mt-30 ml-auto' onClick={myUpdateOrder}>
                <TwinTrans transKey='save'>Guardar</TwinTrans>
            </ButtonPrimary>
        </ModalMedium>
    )
}

interface ModalPersonalizeBookmarksLogicProps {
    bookMarkParsedDict: BookMarkRoutesParsedTy
    setOpened: React.Dispatch<React.SetStateAction<ModalOpenedTy>>
}

const useModalPersonalizeBookmarksLogic = ({ bookMarkParsedDict, setOpened }: ModalPersonalizeBookmarksLogicProps) => {
    const [data, setData] = useState<VerticalSortItem[]>(() => {
        const results: VerticalSortItem[] = []
        for (const key in bookMarkParsedDict) {
            const item = bookMarkParsedDict[key]
            results.push({
                id: item.link,
                name: item?.text,
                order: parseInt(String(item?.key)) + 1
            })
        }
        return results
    })

    const myUpdateOrder = useCallback(async () => {
        let bookMarkRoutes = []
        if (data) {
            for (const element of data) {
                const myBookmark = bookMarkParsedDict[element.id]
                bookMarkRoutes.push({ ...myBookmark, key: element?.order })
            }
        }
        const myValuesStr = JSON.stringify(bookMarkRoutes)
        await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'bookMarkRoutes', value: myValuesStr })
        changeEmployeeParams({ 'bookMarkRoutes': myValuesStr })
        setOpened(null)
    }, [data, bookMarkParsedDict, setOpened])

    return { myUpdateOrder, data, setData }
}

export default ModalPersonalizeBookmarks